import React from "react";
import { useState, useEffect } from "react";
import "../styles/Home.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Modal from "react-bootstrap/Modal";
import logo from "../Assets/imgs/logo.webp";
import heroimage from "../Assets/imgs/dream-job.webp";
import downimage from "../Assets/imgs/dream-job-card.webp";
import ninepearllogo from "../Assets/imgs/companies/9_pearl.webp";
import alfaisallogo from "../Assets/imgs/companies/al_faisal_grey.webp";
import altyerlogo from "../Assets/imgs/companies/al_tyer_grey.webp";
import grilllogo from "../Assets/imgs/companies/grill_grey.webp";
import halogo from "../Assets/imgs/companies/ha_grey.webp";
import klogo from "../Assets/imgs/companies/k_electric.webp";
import nationallogo from "../Assets/imgs/companies/national.webp";
import nestollogo from "../Assets/imgs/companies/netsol_grey.webp";
import sklogo from "../Assets/imgs/companies/sk_tec.webp";
import yemenlogo from "../Assets/imgs/companies/yemen_grey.webp";
import perals from "../Assets/imgs/companies/9-pearl.webp";
import tech from "../Assets/imgs/companies/sk-technologies.webp";
import nes from "../Assets/imgs/companies/netsol.webp";
import fasial from "../Assets/imgs/companies/al-faisal.webp";
import location from "../Assets/imgs/location.png";
import clock from "../Assets/imgs/clock.png";
import search from "../Assets/imgs/search-icon.webp";
import applyjob from "../Assets/imgs/apply-job-icon.webp";
import mobileMenuLogo from "../Assets/imgs/mobile-menu-logo.webp";
import howItWorksDesktop from "../Assets/imgs/hwd-bg.webp";
import howItWorksMobile from "../Assets/imgs/hwm-bg.webp";
import live from "../Assets/imgs/live-interview-icon.webp";
import stick from "../Assets/imgs/stick-img.webp";
import bgsmall from "../Assets/imgs/blue-bg-small.webp";
import trusted from "../Assets/imgs/trusted-companies.webp";

import mobileicon from "../Assets/imgs/humburger-icon.webp";
import mobilestick from "../Assets/imgs/stickmobile.png";
import cross from "../Assets/imgs/cross-icon.webp";
import downloadPopupImage from "../Assets/imgs/download-popup.webp";
import downloadPopupBg from "../Assets/imgs/download-popup-bg.webp";
import downloadPlayStore from "../Assets/imgs/popup-playstore.webp";
import crossPopup from "../Assets/imgs/cross-popup.webp";
import userimage from "../Assets/imgs/user-default.webp";
import menuarrow from "../Assets/imgs/down-arrow.webp";
import { Spinner } from "react-bootstrap";
import Header from "../components/Header";

import Footer from "../components/Footer";

const settings = {
  dots: false,
  arrows: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 1000,
  // speed: 500,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        // Add any other settings you need for this breakpoint
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3, // Adjust the number of slides to show at 767px
        // Add any other settings you need for this breakpoint
      },
    },
  ],
};

const slider2Settings = {
  dots: false,
  arrows: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 2000,
  // speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        // Add any other settings you need for this breakpoint
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1, // Adjust the number of slides to show at 767px
        // Add any other settings you need for this breakpoint
      },
    },
  ],
};

type Props = {
  isSubscribe: boolean;
  handleLogout: () => void;
  handleUnSubscribe: () => void;
  loader: boolean;
  errorMsg: string;
};

const HomePage = (props: Props) => {
  const [downloadPopup, setdownloadPopup] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(true);
  const [isSticky, setIsSticky] = useState(false);
  const [isDropMenu, setIsDropMenu] = useState(true);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const toggleDropMenu = () => {
    setIsDropMenu(!isDropMenu);
  };

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 100) {
        // You can change this value to the desired scroll position
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }                          
    };

    window.addEventListener("scroll", handleScroll);
            
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  //
  return (
    <div className="job-portal">
      {/* download modal */}
      <Modal
        className="download-popup"
        size="lg"
        show={downloadPopup}
        onHide={() => setdownloadPopup(false)}
      >
        <Modal.Body>
          <div className="cross" onClick={() => setdownloadPopup(false)}>
            <img src={crossPopup} alt="cross" />
          </div>
          <div className="pbg-img">
            <img src={downloadPopupBg} width={261} height={397} alt="Vectors" />
          </div>
          <div className="popup-content">
            <div className="left">
              <div className="image">
                <img
                  src={downloadPopupImage}
                  width={303}
                  height={337}
                  alt="pop image"
                />
              </div>
            </div>
            <div className="right">
              <div className="main-content">
                Download <span>JobUp</span> Now & Step into the Professional
                World!
              </div>
              <div className="sub-title">
                Discover your dream job with the JobUp App – Your path to
                professional success begins today.
              </div>
              <div className="button">
                <a
                  href="https://onelink.to/jazzjobup"
                  target="_blank"
                  className="d-button d-button-dark"
                >
                  <img
                    src={downloadPlayStore}
                    width={25}
                    height={28}
                    alt="icon"
                  />{" "}
                  Download Now
                </a>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* header */}
      <Header
        errorMsg={props.errorMsg}
        isSubscribe={props.isSubscribe}
        loader={props.loader}
        handleLogout={() => props.handleLogout()}
        handleUnSubscribe={() => props.handleUnSubscribe()}
      />

      {/* hero panel */}
      <div className="hero-panel-section main-padding">
        <div className="container">
          <div className="row">
            <div
              className="col-md-6"
              data-aos="fade-right"
              data-aos-easing="linear"
              data-aos-duration="1500"
            >
              <div className="hero-panel-text">
                <div className="hero-heading">
                  Connecting<br></br>You to Your<br></br>{" "}
                  <span>Career Ambitions</span>
                </div>
                <div className="hero-text">
                  Where Professionals Come Together to Kickstart Their Careers.
                  A digital networking, collaboration, and growth platform for
                  professionals.
                </div>
                <div className="hero-button">
                  <a
                    href="javascript:;"
                    className="d-button d-button-dark"
                    onClick={() => setdownloadPopup(true)}
                  >
                    Download Now
                  </a>
                </div>
              </div>
            </div>

            <div
              className="col-md-6"
              data-aos="zoom-in"
              data-aos-easing="linear"
              data-aos-duration="500"
            >
              <div className="hero-right-image">
                <div className="hero-image">
                  <img
                    className="lg-img"
                    src={heroimage}
                    width={445}
                    height={527}
                    alt="Your Dream Job"
                  />
                  {/* <img
                    className="sm-img"
                    src={downimage}
                    width={509}
                    height={321}
                    alt="Your Dream Job"
                  /> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* slider section */}

      <div
        className="slider-section"
        data-aos="fade-in"
        data-aos-easing="linear"
        data-aos-duration="500"
      >
        <div className="container">
          <Slider {...settings}>
            <div className="slider-image">
              <img
                src={ninepearllogo}
                width={128}
                height={128}
                alt="company logo"
              />
            </div>
            <div className="slider-image">
              <img
                src={alfaisallogo}
                width={128}
                height={128}
                alt="company logo"
              />
            </div>

            <div className="slider-image">
              <img
                src={altyerlogo}
                width={128}
                height={128}
                alt="company logo"
              />
            </div>

            <div className="slider-image">
              <img
                src={grilllogo}
                width={128}
                height={128}
                alt="company logo"
              />
            </div>

            <div className="slider-image">
              <img src={halogo} width={128} height={128} alt="company logo" />
            </div>
            <div className="slider-image">
              <img src={klogo} width={128} height={128} alt="company logo" />
            </div>

            <div className="slider-image">
              <img
                src={nationallogo}
                width={128}
                height={128}
                alt="company logo"
              />
            </div>

            <div className="slider-image">
              <img
                src={nestollogo}
                width={128}
                height={128}
                alt="company logo"
              />
            </div>

            <div className="slider-image">
              <img src={sklogo} width={128} height={128} alt="company logo" />
            </div>

            <div className="slider-image">
              <img
                src={yemenlogo}
                width={128}
                height={128}
                alt="company logo"
              />
            </div>
          </Slider>
        </div>
      </div>

      {/* featured jobs */}

      <div className="featured-job-section main-padding" id="featured-job">
        <div className="container">
          <div className="row">
            <div
              className="col-md-6 col-12"
              data-aos="fade-right"
              data-aos-easing="linear"
              data-aos-duration="500"
            >
              <div className="main-heading">Featured Jobs</div>
            </div>
            <div
              className="col-md-6 col-12"
              data-aos="fade-right"
              data-aos-easing="linear"
              data-aos-duration="1000"
            >
              <div className="main-text">
                Your ticket to the fast lane. Get ahead of the competition.
                Seize the opportunity of a lifetime.
              </div>
            </div>

            {/* featured content */}
            <div
              className="col-md-12"
              data-aos="zoom-in"
              data-aos-easing="linear"
              data-aos-duration="1000"
            >
              <Slider {...slider2Settings} className="main-padding">
                <div className="featured-content">
                  <div className="image-head">
                    <div className="image-head-logo">
                      <img
                        src={perals}
                        width={50}
                        height={50}
                        alt="Featured logo"
                      />
                    </div>
                    <div className="image-head-text">
                      <span className="image-head-text-head">
                        Sr. UI/UX Designer
                      </span>
                      <div className="jp">O PeralSol</div>
                    </div>
                  </div>

                  <div className="location-content">
                    <div className="location">
                      <img
                        src={location}
                        width={20}
                        height={20}
                        alt="featured icon"
                      />{" "}
                      <span>Islamabad</span>
                    </div>

                    <div className="location clock">
                      <img
                        src={clock}
                        width={20}
                        height={20}
                        alt="featured icon"
                      />{" "}
                      <span>Full Time</span>
                    </div>
                  </div>

                  <div className="featured-content-text">
                    Looking for a Senior UI/UX Designer to join our team and
                    create user-friendly and visually appealing products. You
                    will work closely with product managers and engineers to
                    understand user needs and develop solutions that meet those
                    needs. You will also be responsible for conducting user
                    research, creating wireframes and prototypes, and testing
                    and iterating on designs.
                  </div>

                  <div className="featured-down-content">
                    <div className="price">
                      <div className="price-rte">Rs 85k - 100k</div>
                      <div className="post">Posted 2 days ago</div>
                    </div>

                    <div className="featured-down-link">
                      <a
                        href="javascript:;"
                        className="d-button"
                        onClick={() => setdownloadPopup(true)}
                      >
                        View Job
                      </a>
                    </div>
                  </div>
                </div>

                <div className="featured-content">
                  <div className="image-head">
                    <div className="image-head-logo">
                      <img
                        src={tech}
                        width={50}
                        height={50}
                        alt="Featured logo"
                      />
                    </div>
                    <div className="image-head-text">
                      <span className="image-head-text-head">Accountant</span>
                      <div className="jp">SKY Technologies</div>
                    </div>
                  </div>

                  <div className="location-content">
                    <div className="location">
                      <img
                        src={location}
                        width={20}
                        height={20}
                        alt="featured icon"
                      />{" "}
                      <span>Lahore</span>
                    </div>

                    <div className="location clock">
                      <img
                        src={clock}
                        width={20}
                        height={20}
                        alt="featured icon"
                      />{" "}
                      <span>Full Time</span>
                    </div>
                  </div>

                  <div className="featured-content-text">
                    We are looking for a highly motivated and experienced
                    accountant to join our team. The ideal candidate will have a
                    strong understanding of accounting principles and practices,
                    as well as experience with financial reporting and tax
                    preparation. You will be responsible for managing our
                    financial records, preparing financial statements, and
                    ensuring that we are in compliance with all tax laws.
                  </div>

                  <div className="featured-down-content">
                    <div className="price">
                      <div className="price-rte">Rs 75k - 95k</div>
                      <div className="post">Posted 4 days ago</div>
                    </div>

                    <div className="featured-down-link">
                      <a
                        href="javascript:;"
                        className="d-button"
                        onClick={() => setdownloadPopup(true)}
                      >
                        View Job
                      </a>
                    </div>
                  </div>
                </div>

                <div className="featured-content">
                  <div className="image-head">
                    <div className="image-head-logo">
                      <img
                        src={nes}
                        width={50}
                        height={50}
                        alt="Featured logo"
                      />
                    </div>
                    <div className="image-head-text">
                      <span className="image-head-text-head">
                        Digital Marketer
                      </span>
                      <div className="jp">Nexus Technologies</div>
                    </div>
                  </div>

                  <div className="location-content">
                    <div className="location">
                      <img
                        src={location}
                        width={20}
                        height={20}
                        alt="featured icon"
                      />{" "}
                      <span>Islamabad</span>
                    </div>

                    <div className="location clock">
                      <img
                        src={clock}
                        width={20}
                        height={20}
                        alt="featured icon"
                      />{" "}
                      <span>Part Time</span>
                    </div>
                  </div>

                  <div className="featured-content-text">
                    We are looking for a creative and results-oriented Digital
                    Marketer to join our team. You will be responsible for
                    developing and executing digital marketing campaigns across
                    all channels, including social media, search engine
                    optimization (SEO), and pay-per-click (PPC) advertising. You
                    will also be responsible for measuring and analyzing the
                    results of our campaigns to ensure that we are meeting our
                    goals.
                  </div>

                  <div className="featured-down-content">
                    <div className="price">
                      <div className="price-rte">Rs 50k - 70k</div>
                      <div className="post">Posted 7 days ago</div>
                    </div>

                    <div className="featured-down-link">
                      <a
                        href="javascript:;"
                        className="d-button"
                        onClick={() => setdownloadPopup(true)}
                      >
                        View Job
                      </a>
                    </div>
                  </div>
                </div>

                <div className="featured-content">
                  <div className="image-head">
                    <div className="image-head-logo">
                      <img
                        src={fasial}
                        width={50}
                        height={50}
                        alt="Featured logo"
                      />
                    </div>
                    <div className="image-head-text">
                      <span className="image-head-text-head">Carpenter</span>
                      <div className="jp">Al Hameed Carpentry & Interior</div>
                    </div>
                  </div>

                  <div className="location-content">
                    <div className="location">
                      <img
                        src={location}
                        width={20}
                        height={20}
                        alt="featured icon"
                      />{" "}
                      <span>Gujrat</span>
                    </div>

                    <div className="location clock">
                      <img
                        src={clock}
                        width={20}
                        height={20}
                        alt="featured icon"
                      />{" "}
                      <span>Full Time</span>
                    </div>
                  </div>

                  <div className="featured-content-text">
                    We're hiring a skilled carpenter with expertise in
                    woodworking, blueprint interpretation, and carpentry tools.
                    Your role will involve creating, repairing, and installing
                    wood structures and components. Strong attention to detail
                    and safety practices are essential. Join our team for
                    rewarding construction projects.
                  </div>

                  <div className="featured-down-content">
                    <div className="price">
                      <div className="price-rte">Rs 13k - 60k</div>
                      <div className="post">Posted 10 days ago</div>
                    </div>

                    <div className="featured-down-link">
                      <a
                        href="javascript:;"
                        className="d-button"
                        onClick={() => setdownloadPopup(true)}
                      >
                        View Job
                      </a>
                    </div>
                  </div>
                </div>
              </Slider>
            </div>
          </div>
        </div>
      </div>

      {/* how it work */}

      <div
        className="howwork main-padding "
        id="howitwork"
        data-aos="fade-down"
        data-aos-easing="linear"
        data-aos-duration="1000"
      >
        <div className="container">
          <div className="hw-data">
            <div className="hw-bg">
              <img
                src={howItWorksDesktop}
                className="hw-desktop"
                width={1296}
                height={554}
                alt="desktop-bg"
              />
              <img
                src={howItWorksMobile}
                className="hw-mobile"
                width={316}
                height={840}
                alt="mobile-bg"
              />
            </div>

            <div className="row hw-row">
              <div className="col-md-12">
                <div className="howwork-bg">
                  {/* <div className="how-image">
                  <img src={stick} />
                </div>
                <div className="how-image-mobile">
                  <img src={mobilestick} />
                </div> */}
                  <div className="row">
                    <div className="col-lg-7 col-md-8">
                      <div className="howwork-content">
                        <div className="how-head"> How Jobup works</div>
                        <div className="how-text">
                          Jobup, a job search platform, facilitates
                          skill-matched job discovery for seekers and assists
                          employers in sourcing qualified candidates, offering
                          various supportive features for both parties.
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card-content">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="card">
                          <div className="card-head">
                            <div className="card-image">
                              <img
                                src={search}
                                width={50}
                                height={50}
                                alt="work-icon"
                              />
                            </div>

                            <div className="card-head-text">Search Job</div>
                          </div>

                          <div className="card-text">
                            Effortlessly find jobs matching your skills and
                            interests using search filters, and receive search
                            results and job alerts tailored to your preferences.
                          </div>
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="card">
                          <div className="card-head">
                            <div className="card-image">
                              <img
                                src={applyjob}
                                width={50}
                                height={50}
                                alt="work-icon"
                              />
                            </div>

                            <div className="card-head-text">Apply Job</div>
                          </div>

                          <div className="card-text">
                            Apply for jobs quickly with minimal effort, and
                            conveniently save and monitor your application
                            details and progress for future reference.
                          </div>
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="card">
                          <div className="card-head">
                            <div className="card-image">
                              <img
                                src={live}
                                width={50}
                                height={50}
                                alt="work-icon"
                              />
                            </div>

                            <div className="card-head-text">
                              Job Recommendations
                            </div>
                          </div>

                          <div className="card-text">
                            JobUp streamlines job searches with personalised
                            recommendations based on user preferences, skills,
                            and interests, simplifying the job hunting
                            experience.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* job category */}

      <div
        className="job-category main-padding"
        id="category"
        data-aos="zoom-in"
        data-aos-easing="linear"
        data-aos-duration="500"
      >
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="main-heading">Job Categories</div>
            </div>
            <div className="col-md-6">
              <div className="main-text">
                A way to browse jobs by their industry, function, or skill set.
                Find jobs that match your skills, interests, and career goals.
              </div>
            </div>
          </div>

          <div className="jobs-inner ">
            <div className="row">
              <div className="col-lg-7 col-md-6">
                <div className="job-box-wraper">
                  <div className="box1">Electrician</div>
                  <div className="box1 box2">Web Developer</div>
                  <div className="box1">Photographer</div>
                  <div className="box1">Accountant</div>
                </div>
              </div>
              <div className="col-lg-5 col-md-6 col-12">
                <div className="jobs-right">
                  <img src={bgsmall} width={516} height={405} alt="bg-blue" />

                  <div className="jobs-right-text">
                    Check <br /> Our Featured <br /> Jobs Catagories
                  </div>
                  <a
                    href="javascript:;"
                    className="d-button d-button-dark"
                    onClick={() => setdownloadPopup(true)}
                  >
                    See All Categories
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* unlock  section*/}
      <div
        className="unlock-section main-padding"
        data-aos="fade-in"
        data-aos-easing="linear"
        data-aos-duration="1000"
      >
        <div className="container">
          <div className="unlock-bg">
            <div className="row">
              <div className="col-md-5">
                <img
                  src={trusted}
                  width={357}
                  height={374}
                  alt="trusted-image"
                />
              </div>
              <div className="col-md-7 col-12">
                <div className="unlock-right-text">
                  <div className="unlock-right-head">
                    Unlock Opportunities – Download JobUp
                  </div>
                  <div className="sub-heading">
                    Discover your dream job with the Jobup app – your path to
                    professional success begins today. Download Now!
                  </div>
                  <div className="unlock-right-button">
                    <a
                      href="javascript:;"
                      className="d-button"
                      onClick={() => setdownloadPopup(true)}
                    >
                      Download JobUp
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* footer */}
      <Footer />
    </div>
  );
};

export default HomePage;
